// extracted by mini-css-extract-plugin
module.exports = {"link":"LinkRow_link__1Di2w","center":"LinkRow_center__3tPkR","right":"LinkRow_right__3iQqY"};